// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgHeatPumpIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path
      fillRule="evenodd"
      d="M7 3h10c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1m9.3 5.41a.57.57 0 0 0-.64-.47l.01-.01-3.19.46c-.3.05-.51.33-.47.64.04.28.28.48.55.48h.08l3.19-.46c.3-.05.51-.33.47-.64M11.19 6.3l-1.2 2.99a.556.556 0 0 0 .52.77c.22 0 .43-.13.52-.35l1.2-2.99a.556.556 0 0 0-.31-.73.556.556 0 0 0-.73.31M8.42 8.66a.57.57 0 0 0-.79-.09c-.24.19-.28.55-.09.79l1.99 2.53a.57.57 0 0 0 .79.09c.24-.19.28-.55.09-.79zm-.14 5.39h.09l3.19-.46c.3-.05.51-.33.47-.64a.57.57 0 0 0-.64-.48l-3.19.46c-.3.05-.51.33-.47.64.04.28.28.48.55.48m4.55 1.64 1.2-2.99a.556.556 0 0 0-.31-.73.556.556 0 0 0-.73.31l-1.2 2.99a.556.556 0 0 0 .52.77c.22 0 .43-.13.52-.35m3.21-2.15c.12 0 .25-.04.35-.12.24-.19.28-.55.09-.79l-1.99-2.53a.57.57 0 0 0-.79-.09c-.24.19-.28.55-.09.79l1.99 2.53c.11.14.27.21.44.21M8.01 21c0 .55.45 1 1 1s1-.45 1-1v-1h-2zm6 0c0 .55.45 1 1 1s1-.45 1-1v-1h-2z"
      clipRule="evenodd"
    />
  </Icon>
);
export default SvgHeatPumpIcon;
SvgHeatPumpIcon.displayName = 'SvgHeatPumpIcon';
